import styled, { css } from "styled-components";
import tw from "twin.macro";

import { BoxSizingStyle } from "../../BoxSizingStyle";
import { ButtonGroup } from "../../ButtonGroup";
import { FontStyle } from "../../FontStyle";
import { IconButton } from "../../IconButton";
import { Menu } from "../../Menu";

export const StyledButton = styled.button`
  ${FontStyle}
  ${BoxSizingStyle}

  ${tw`
    tw-relative
    tw-antialiased
    tw-align-middle
    tw-font-medium
    tw-inline-block
    tw-leading-none
    tw-m-0
    tw-no-underline
    tw-text-sm
    tw-select-none
    tw-cursor-pointer
    tw-text-center
  `}

  color: var(--color-theme-700);
  margin: 0;
  padding: 0;
  background: none;
  width: 100%;
  height: auto;
  border: none;
  height: 30px;
  line-height: 1;
  transition: all 0.3s ease;

  svg {
    fill: currentColor;
  }

  &::-moz-focus-inner {
    border: 0;
  }

  &:focus {
    outline: none;
  }

  &:hover {
    text-decoration: none;
  }

  &:disabled {
    cursor: default;
    opacity: 50%;
    pointer-events: none;
  }
`;

export const StyledMenu = styled(Menu)`
  ${tw`
    tw-w-auto
    tw-h-auto
    tw-py-4
    tw-px-2
  `}
`;

export const StyledButtonGroup = styled(ButtonGroup)`
  ${FontStyle}
  ${BoxSizingStyle}

  button:hover {
    position: relative;
    z-index: 1;
  }
`;

export const StyledSpan = styled.span`
  line-height: 30px;
  color: var(--color-theme-700);
`;

interface StyledDiv {
  $isTargetable: boolean;
  $isRounded: boolean;
  $mode: string;
  $alwaysShowDate: boolean;
}

export const StyledDiv = styled.div<StyledDiv>`
  ${(props) =>
    props.$isTargetable &&
    css`
      ${tw`tw-pointer-events-none`}
    `}

  ${(props) =>
    props.$isRounded &&
    css`
      border-radius: var(--ac-br-rounded);
    `}

    ${(props) =>
    props.$mode !== "flat"
      ? tw`
            tw-border
            tw-border-solid
          `
      : tw`tw-border-0`}

  ${tw`
    tw-relative
    tw-text-center
    tw-p-0
    tw-antialiased
    tw-align-middle
    tw-font-medium
    tw-inline-block
    tw-leading-none
    tw-m-0
    tw-no-underline
    tw-text-sm
    tw-select-none
    tw-cursor-pointer
  `}

  height: 32px;
  transition: all 0.3s ease;
  background-color: transparent;
  ${(props) =>
    props.$mode !== "flat" &&
    css`
      border: 1px solid var(--color-theme-700);
    `}

  color: var(--color-theme-700);
  margin-right: -1px;
  display: block;

  ${(props) =>
    !props.$alwaysShowDate &&
    css`
      @media (max-width: 768px) {
        display: none;
      }
    `}
  svg {
    fill: currentColor;
  }

  &::-moz-focus-inner {
    border: 0;
  }

  &:focus {
    outline: none;
  }

  &:disabled {
    cursor: default;
    opacity: 50%;
    pointer-events: none;
  }

  &:hover {
    ${(props) =>
      props.$mode !== "flat" &&
      css`
        border-color: var(--color-primary);
      `}
    color: var(--color-primary);
    text-decoration: none;
  }

  &:active {
    ${(props) =>
      props.$mode !== "flat" &&
      css`
        border-color: var(--color-primary);
        background-color: var(--color-primary-200);
      `}
    color: var(--color-primary);
  }
`;

export const StyledControl = styled(IconButton)`
  border-radius: var(--ac-br-8);
`;

StyledButtonGroup.displayName = "StyledButtonGroup";
StyledSpan.displayName = "StyledSpan";
StyledDiv.displayName = "StyledDiv";
StyledMenu.displayName = "StyledMenu";
StyledButton.displayName = "StyledButton";
StyledControl.displayName = "StyledControl";
